/**
 * Collection-grid image alts  (dev request 4)
 *
 * Mobile swipe needs no JavaScript at all - the track is a CSS scroll-snap
 * container, so touch scrolling is native and momentum/rubber-banding come free.
 * This file exists only for the desktop arrows, which need scrollBy.
 *
 * Two things worth knowing:
 *
 * 1. The whole card is wrapped in an <a>. An arrow click inside that anchor would
 *    navigate to the PDP, so the handler must preventDefault AND stopPropagation.
 * 2. Product grids are re-rendered by the pagination/facet controllers, so this is
 *    delegated from `document` rather than bound per-card.
 */
(function () {
  'use strict';

  var NAV_SELECTOR = '[data-card-gallery-nav]';

  function trackFor(button) {
    var gallery = button.closest('[data-card-gallery]');
    return gallery ? gallery.querySelector('[data-card-gallery-track]') : null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest(NAV_SELECTOR) : null;
    if (!button) return;

    // Stop the click reaching the product-card anchor.
    event.preventDefault();
    event.stopPropagation();

    var track = trackFor(button);
    if (!track) return;

    var direction = button.getAttribute('data-card-gallery-nav') === 'next' ? 1 : -1;
    var slide = track.firstElementChild;
    var distance = slide ? slide.getBoundingClientRect().width : track.clientWidth;

    track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  });

  /**
   * A drag that ends on the card can fire a click and navigate to the PDP, which
   * makes swiping feel broken. Suppress the click when the track actually moved.
   */
  document.addEventListener(
    'pointerdown',
    function (event) {
      var track = event.target && event.target.closest
        ? event.target.closest('[data-card-gallery-track]')
        : null;
      if (!track) return;
      track.dataset.dragStart = String(track.scrollLeft);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var track = event.target && event.target.closest
        ? event.target.closest('[data-card-gallery-track]')
        : null;
      if (!track || track.dataset.dragStart === undefined) return;

      var moved = Math.abs(track.scrollLeft - Number(track.dataset.dragStart)) > 5;
      delete track.dataset.dragStart;

      if (moved) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
